<template>
  <div style="background-color: white; min-height: 100vh;">
    <Header type="white" />
    <WhoAreWe :data="kurumsalData" />
    <OurAims :data="kurumsalData" type="light" title="Hedeflerimiz" head="ŞİRKETİMİZ" />
    <Misyon :data="kurumsalData" type="light" title="Misyon & Vizyon" head="ŞİRKETİMİZ" />
    <Footer />
  </div>
</template>

<script>
import AOS from "aos";
import Header from "../components/common/Header";
import WhoAreWe from "../components/about-us/WhoAreWe";
import Misyon from "../components/about-us/Misyon";
import OurAims from "../components/about-us/OurAims";
import Footer from "../components/common/Footer";
import { getFirestore, doc, onSnapshot } from "firebase/firestore";
import { initializeApp, getApps, getApp } from "firebase/app";

const firebaseConfig = { apiKey: "AIzaSyBxpNV_8UazGQ3pMReWWIdROn7AZlMT17Y", authDomain: "baumind-45d99.firebaseapp.com", projectId: "baumind-45d99", storageBucket: "baumind-45d99.firebasestorage.app", messagingSenderId: "982282716223", appId: "1:982282716223:web:25ebcf827c8e87c555248a" };
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const db = getFirestore(app);

export default {
  name: "AboutUs",
  components: { Header, WhoAreWe, OurAims, Misyon, Footer },
  data() { return { kurumsalData: { bizKimizText: '', bizKimizImage: '', hedefler: '', misyon: '', vizyon: '' } }; },
  mounted() {
    AOS.init({ once: true });
    onSnapshot(doc(db, "ayarlar", "kurumsal"), (docSnap) => { if (docSnap.exists()) this.kurumsalData = docSnap.data(); });
  }
};
</script>